import { createSlice } from '@reduxjs/toolkit'

export interface IMatchListsDataState {
    pagination: {
        itemsPerPage: number
        currentPage: number
        total: number
    }
    searchValue: string | null
    filters?: any
    sort?: string
    projection?: any
    needPopulate: boolean
    populates?: any
    selectedRowKeys?: string[]
}

const initialState: IMatchListsDataState = {
    pagination: {
        itemsPerPage: 10,
        currentPage: 1,
        total: 0
    },
    searchValue: null,
    filters: {},
    sort: '-createdAt',
    projection: [],
    needPopulate: true,
    populates: [{ path: 'ownerCompany', select: '_id name' }],
    selectedRowKeys: []
}

const matchListsSlice = createSlice({
    name: 'ui/match-list',
    initialState,
    reducers: {
        onChangePagination(state, action) {
            state.pagination = { ...state.pagination, ...action.payload }
        },
        onChangeSelectedRows(state, action) {
            state.selectedRowKeys = action.payload
        },
        onChangeSearch(state, action) {
            state.searchValue = action.payload
        },
        onChangeTotal(state, action) {
            state.pagination = { ...state.pagination, total: action.payload }
        }
    }
})

export const matchListsActions = matchListsSlice.actions
export default matchListsSlice.reducer
